import { path } from 'ramda';

import { FEATURE_NAME as $, LIST, FILTERS } from './consts';

export const getProjects = path([$, LIST]);
export const getProject = (id) => path([$, LIST, id]);
export const getProjectProp = (id) => (name) => path([$, LIST, id, name]);
export const getProjectsFilters = path([$, FILTERS]);
